var _PROGRESS_INDICATOR_T;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import gettext from 'js-utils/gettext';
import { STYLES, STYLE_GRADIENT, STYLE_PROGRESS, STYLE_CONFIG, TYPES, TYPE_INDETERMINATE, TYPE_DETERMINATE } from './constants';
import { getStyleByProgress } from './utils';

var Indeterminate = function Indeterminate(_ref) {
  var style = _ref.style,
      stopColor1 = _ref.stopColor1,
      railColor = _ref.railColor;
  var indicatorStyles = {
    backgroundColor: stopColor1
  };
  var railStyles = {
    backgroundColor: railColor
  };
  var className = classNames('eds-progress-indicator--linear__line', 'eds-progress-indicator--linear-indeterminate__line', {
    'eds-bg-color--ui-orange': style === STYLE_GRADIENT
  });
  return React.createElement("div", {
    className: "eds-progress-indicator--linear__rail",
    style: railStyles,
    "aria-valuetext": gettext('In progress')
  }, React.createElement("div", {
    className: className,
    style: indicatorStyles
  }));
};

var Determinate = function Determinate(_ref2) {
  var style = _ref2.style,
      stopColor1 = _ref2.stopColor1,
      railColor = _ref2.railColor,
      progress = _ref2.progress;
  var indicatorStyles = {
    width: "".concat(progress, "%"),
    backgroundColor: stopColor1
  };
  var railStyles = {
    backgroundColor: railColor
  };
  var className = classNames('eds-progress-indicator--linear__line', 'eds-progress-indicator--linear-determinate__line', {
    'eds-bg-color--vibrant-green': style === STYLE_GRADIENT
  });
  return React.createElement("div", {
    className: "eds-progress-indicator--linear__rail",
    style: railStyles,
    role: "progressbar",
    "aria-valuenow": progress,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }, React.createElement("div", {
    className: className,
    style: indicatorStyles
  }));
};

var PROGRESS_INDICATOR_TYPE_MAP = (_PROGRESS_INDICATOR_T = {}, _defineProperty(_PROGRESS_INDICATOR_T, TYPE_INDETERMINATE, Indeterminate), _defineProperty(_PROGRESS_INDICATOR_T, TYPE_DETERMINATE, Determinate), _PROGRESS_INDICATOR_T);

var Linear =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Linear, _React$PureComponent);

  function Linear() {
    _classCallCheck(this, Linear);

    return _possibleConstructorReturn(this, _getPrototypeOf(Linear).apply(this, arguments));
  }

  _createClass(Linear, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          type = _this$props.type,
          progress = _this$props.progress;

      var _ref3 = style === STYLE_PROGRESS ? getStyleByProgress(progress) : STYLE_CONFIG[style],
          stopColor1 = _ref3.stopColor1,
          stopColor2 = _ref3.stopColor2,
          railColor = _ref3.railColor;

      var Component = PROGRESS_INDICATOR_TYPE_MAP[type];
      return React.createElement(Component, {
        style: style,
        stopColor1: stopColor1,
        stopColor2: stopColor2,
        railColor: railColor,
        progress: progress
      });
    }
  }]);

  return Linear;
}(React.PureComponent);

_defineProperty(Linear, "propTypes", {
  /**
  * Type of indicator for the loader (indeterminate | determinate)
  */
  type: PropTypes.oneOf(TYPES),

  /**
  * Color of the loader (dark | light | gradient)
  */
  style: PropTypes.oneOf(STYLES),

  /**
  * Progress bar if the chosen Type is determinate
  */
  progress: PropTypes.number
});

export { Linear as default };